(function(angular){
	'use strict';

	angular
		.module('apiModule')
		.factory('CheckoutFactory', [
			'$filter',
			'$q',
			'HTTP_STATUS',
			'INVESTMENT_ENTITY_ID',
			'urlFactory',
			checkoutFactoryFunction
		]);

	function checkoutFactoryFunction(
		$filter,
		$q,
		HTTP_STATUS,
		INVESTMENT_ENTITY_ID,
		urlFactory
	) {
		var factory = {
			linkPaymentToOrder: linkPaymentToOrder,
			createOrderGroup: createOrderGroup,
			getDocumentsAndAgreements: getDocumentsAndAgreements,
			getInvestmentRange: getInvestmentRange,
			placeOrder: placeOrder,
			getOrderGroup: getOrderGroup
		};

		return factory;

		function linkPaymentToOrder(orderGroupId, payload, redirectUrl) {
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/order-group/' + orderGroupId + '/attach-bank-account';

			return urlFactory.apiPostPromise(url, payload)
				.then(function(response) {
					return response.data;
				})
				.catch(function(response) {
					if(response.status === HTTP_STATUS.BAD_REQUEST) {
						urlFactory.redirect(redirectUrl);
					} else {
						urlFactory.handleFailedRequest(response);
					}
					return $q.reject(response);
				});
		}

		function createOrderGroup(payload, form) {
			var deferred = $q.defer();
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/investment/order-group';

			urlFactory.apiPostPromise(url, payload)
				.then(function (response) {
					deferred.resolve(response.data);
				})
				.catch(function (response) {
					if(response.status === HTTP_STATUS.BAD_REQUEST || response.status === HTTP_STATUS.CONFLICT && angular.isDefined(form)) {
						urlFactory.handleServerValidation(form, response);
					} else {
						urlFactory.handleFailedRequest(response);
					}

					deferred.reject();
				});

			return deferred.promise;
		}

		function getDocumentsAndAgreements(orderGroupId) {
			var deferred = $q.defer();
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/investment/order-group/' + orderGroupId + '/acknowledgments';

			urlFactory.apiGetPromise(url)
				.then(function(response) {
					var resolved = {};
					angular.extend(resolved, response.data);

					resolved.reitDocumentIds = $filter('map')(resolved.reitDocuments, function(reitDocument) {
						return Number(reitDocument.documentRevisionId);
					}).join(',');

					deferred.resolve(resolved);
				})
				.catch(function () {
					deferred.reject();
				});

			return deferred.promise;
		}

		function getInvestmentRange(orderDetailsObj) {
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID;

			if(angular.isDefined(orderDetailsObj.isRepeatRia) && orderDetailsObj.isRepeatRia) {
				url += '/ria/investment-range';
			} else if (angular.isDefined(orderDetailsObj.reitOfferingVintageId)) {
				url += '/reit-offering-vintage/' + orderDetailsObj.reitOfferingVintageId + '/investment-range';
			} else if(angular.isDefined(orderDetailsObj.serviceLevel)) {
				url += '/service-level/' + orderDetailsObj.serviceLevel + '/ria-plan/' + orderDetailsObj.riaPlanId + '/investment-range';
			} else if(angular.isDefined(orderDetailsObj.riaPlanId)) {
				url += '/ria-plan/' + orderDetailsObj.riaPlanId + '/investment-range';
			}

			return urlFactory.apiGetPromise(url)
				.then(function(response) {
					return response.data;
				});
		}

		function placeOrder(payload, orderGroupId) {
			var deferred = $q.defer();
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/investment/order-group/' + orderGroupId + '/place-order';

			urlFactory.apiPostPromise(url, payload)
				.then(function (response) {
					deferred.resolve(response.data);
				})
				.catch(function (response) {
					urlFactory.handleFailedRequest(response);
					deferred.reject();
				});

			return deferred.promise;
		}

		function getOrderGroup(orderGroupId) {
			var deferred = $q.defer();
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/investment/order-group/' + orderGroupId;

			urlFactory.apiGetPromise(url)
				.then(function(response) {
					deferred.resolve(response.data);
				})
				.catch(function (response) {
					deferred.reject(response);
				});

			return deferred.promise;
		}

	}
})(window.angular);